import { useMemo } from "react";
import useGroups from "admin/hooks/useGroups";
import { UserGroup } from "admin/types/interfaces/user";
import { excludeSystemTags } from "admin/utils/tags";
import { Checkbox } from "~/components/ui/checkbox";
import { Label } from "~/components/ui/label";

const GroupSelector = ({
  selectedGroups,
  setSelectedGroups,
  disabled = false,
}: {
  selectedGroups: UserGroup[];
  setSelectedGroups: (groups: UserGroup[]) => void;
  disabled?: boolean;
}) => {
  const { data: allGroups = [] } = useGroups();
  const visibleGroups = useMemo(() => excludeSystemTags(allGroups), [allGroups]);

  if (visibleGroups.length === 0) {
    return <p className="text-sm text-muted-foreground py-3">No groups available.</p>;
  }

  return (
    <div className="flex flex-col divide-y divide-border">
      {visibleGroups.map((group) => {
        const isChecked = selectedGroups.some((g) => g.name === group.name);
        return (
          <div key={group.name} className="flex gap-3 py-3 first:border-t last:pb-0">
            <Checkbox
              id={`group-${group.name}`}
              disabled={disabled}
              checked={isChecked}
              onCheckedChange={(checked) => {
                if (checked) {
                  setSelectedGroups([...selectedGroups, group]);
                } else {
                  setSelectedGroups(selectedGroups.filter((g) => g.name !== group.name));
                }
              }}
            />
            <div className="flex flex-col gap-1">
              <Label className="leading-[18px]" htmlFor={`group-${group.name}`}>
                {group.display_name || group.name}
              </Label>
              {group.description && (
                <p className="text-xs text-muted-foreground">{group.description}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GroupSelector;
